import VueBaseController from '../../vue_base'

export class IndexController extends VueBaseController {
  static get ASYNC_COMPONENT() {
    return () => import('@/vue/pages/users/index_checker/projects/index.vue')
  }
}

export class ShowController extends VueBaseController {
  static get ASYNC_COMPONENT() {
    return () => import('@/vue/pages/users/index_checker/projects/show.vue')
  }
  static values = { projectId: String }
}

export class NewController extends VueBaseController {
  static get ASYNC_COMPONENT() {
    return () => import('@/vue/pages/users/index_checker/projects/new.vue')
  }
}

export class EditController extends VueBaseController {
  static get ASYNC_COMPONENT() {
    return () => import('@/vue/pages/users/index_checker/projects/edit.vue')
  }
  static values = { projectId: String }
}
